export const STORE_CLEAR = 'STORE_CLEAR';



// WEBPACK FOOTER //
// ./app/constants/storeTypes.js